export const menuData = [
  { title: 'Home', Link: '/' },
  {
    title: 'Study Abroad',
    Link: null,
    dropdown: [
      { title: 'Study in UK', Link: '/study-abroad/uk' },
      { title: 'Study in USA', Link: '/study-abroad/usa' },
      { title: 'Study in Canada', Link: '/study-abroad/canada' },
      { title: 'Study in Australia', Link: '/study-abroad/australia' },
      { title: 'Study in Singapore', Link: '/study-abroad/singapore' },
      { title: 'Study in Thailand', Link: '/study-abroad/thailand' },
    ],
  },
  {
    title: 'Our Services',
    Link: '/services',
    dropdown: [
      { title: 'Education Counseling', Link: '/services/education-counseling' },
      { title: 'Application Process', Link: '/services/application-process' },
      { title: 'Visa Guidance', Link: '/services/visa-application' },
      { title: 'Scholarship Guidance', Link: '/services/scholarship-application' },
      { title: 'Predeparture Guidance', Link: '/services/predeparture-guidance' },
      { title: 'Payment', Link: '/services/payment' },
    ],
  },
  {
    title: 'Company',
    Link: null,
    dropdown: [
      { title: 'About Us', Link: '/company/about-us' },
      { title: 'News & Blog', Link: '/company/news-blog' },
      { title: 'Testimonials', Link: '/company/testimonials' },
      { title: 'Contact Us', Link: '/company/contact' },
      { title: 'Office Tour', Link: '/company/office-tour' },
    ],
  },
];

  